import { Component, OnInit, OnDestroy, OnChanges, HostBinding, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { Observable, Subscription, Subject } from 'rxjs/Rx';

import { BlockingSpinnerService } from 'app/core/blocking-spinner/blocking-spinner.service';
import { CheckoutService } from 'app/shared/checkout/checkout.service';
import { BoletoService } from './boleto/boleto.service';

import CartaoCredito from 'models/cartao-credito';
import { Checkout, CheckoutConfig } from 'models/checkout';
import { DadosPagamento } from 'models/dados-pagamento';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';


//CONFIGURAÇÂO PARA EURO - 01/07/2021
//const SIGLA_CARTOES = { 'visa': '4', 'master': '6', 'diners': '12' };


@Component({
  moduleId: module.id.toString(),
  templateUrl: './pagamento.component.html',
  styleUrls: ['./pagamento.component.scss'],
  selector: 'pagamento',
})
export class PagamentoComponent implements OnInit, OnDestroy, OnChanges {
  @HostBinding('style.display') display = 'block';

  formaPagamento: any = undefined;
  cartoes: CartaoCredito[] = [];
  configuracoesCartoes: Subject<CheckoutConfig[]> = new Subject<CheckoutConfig[]>();
  formasPagamento: any[] = [];
  validarCartaoTimeout = null;
  dadosPagamentoLocal: DadosPagamento = new DadosPagamento({});
  configuracoesCheckout: CheckoutConfig[];
  environment = environment;

  //CONFIGURAÇÂO PARA EURO - 01/07/2021
  public sigla_cartoes: Object = { 'visa': '4', 'master': '6', 'diners': '12' };

  private obsDadosPagamento: Subscription;

  @Input() apresentarTitulo = true;
  @Input() showAlert = false;
  @Input() buttonAlert = false;
  @Input() dadosPagamento: Observable<DadosPagamento>;
  @Output() onPagamentoSucesso: EventEmitter<any> = new EventEmitter();
  @Output() onMudancaFormaPagamento: EventEmitter<any> = new EventEmitter();

  constructor(
    private boletoService: BoletoService,
    private notification: NotificationsService,
    private checkoutService: CheckoutService,
    private spinner: BlockingSpinnerService,
    private router: Router
  ) {
   }

  ngOnInit() {
    this.formasPagamento = [
      { id: 'boleto', nome: 'Boleto Bancário' },
      { id: 'cartao', nome: 'Cartão de Crédito' },
    ];

    //CONFIGURAÇÂO PARA EURO - 01/07/2021
    if(environment.loginContexto === 'EURO'){
      this.sigla_cartoes = { 'visa': '4', 'master': '6', 'diners': '12', 'elo': '7' };
    }

    this.obsDadosPagamento = this.dadosPagamento.subscribe((dadosPagamento: DadosPagamento) => {
      this.reset();
      this.dadosPagamentoLocal = dadosPagamento;
      //console.log(this.dadosPagamentoLocal)
    });
  }

  ngOnDestroy() {
    if (this.obsDadosPagamento) {
      this.obsDadosPagamento.unsubscribe();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    // Reinicia as configurações de pagamento quando os dados de inscrição são modificados
    if (changes.dadosInscricao) {
      this.reset();
    }
  }

  carregarConfiguracoesParaCartao(codigoSistema) {
    //console.log(this.configuracoesCheckout);
    //console.log(this.configuracoesCartoes);
    if (this.configuracoesCheckout && this.configuracoesCheckout.length > 0) {
      this.configuracoesCartoes.next(this.configuracoesCheckout);
    } else {
      //console.log(codigoSistema);
      this.spinner.show();
      this.checkoutService.getConfiguracoes(codigoSistema).subscribe(
        (configs: CheckoutConfig[]) => {
          this.configuracoesCheckout = configs;
          this.configuracoesCartoes.next(configs);
          this.spinner.close();
          //console.log(this.configuracoesCheckout);
        },
      );
    }
  }

  mudancaFormaPagamento(formaPagamento: string) {
    if (this.onMudancaFormaPagamento) {
      if (formaPagamento === 'cartao') {
        this.carregarConfiguracoesParaCartao(this.dadosPagamentoLocal.sistema.codigoSistema);
      }
      this.onMudancaFormaPagamento.emit(formaPagamento);
    }
  }

  reset() {
    delete this.configuracoesCheckout;
    this.resetInputs();
  }

  resetInputs() {
    this.formaPagamento = null;
    this.cartoes = [];
  }

  pagamentoBoleto() {
    this.boletoService.gerarPDF(this.dadosPagamentoLocal);
    this.concluirPagamento(this.formasPagamento[0]);
  }

  // Callback do Componente de Cartões de Crédito
  pagamentoCartao(dadosPagamento) {
    //console.log(dadosPagamento);
    this.dadosPagamentoLocal.configuracao = dadosPagamento.configuracao;
    this.dadosPagamentoLocal.cartao = dadosPagamento.cartoes.map((cartao: CartaoCredito) => ({
      agrupador: 0,
      anoValidade: cartao.anoVencimento,
      bandeiraCod: this.sigla_cartoes[cartao.bandeira],
      cvv: cartao.cvv,
      mesValidade: cartao.mesVencimento,
      nomeTitular: cartao.nomeCartao,
      numCartao: cartao.numeroCartao,
      numFinalCartao: '',
      numeroPedido: '',
      qtdParcelas: cartao.numeroParcelas,
      tidRede: '',
      valor: cartao.valor,
    }));

    this.dadosPagamentoLocal.perfil = {
      codigo: this.configuracoesCheckout[0].codigo,
    };

    const parcelas = [{
      anoBol: this.dadosPagamentoLocal.dadosPessoais.anoSem,
      sequencial: '01',
      valorParcela: this.dadosPagamentoLocal.cartao[0].valor,
      desconto: 0.0,
      valorMulta: 0.0,
      obsQuitacao: '',
      situacaoBoleto: null,
      numeroParcela: this.dadosPagamentoLocal.cartao[0].numeroParcelas,
      numeroTotalParcelas: this.dadosPagamentoLocal.cartao[0].numeroParcelas,
    }];

    const checkout = new Checkout({
      cartao: this.dadosPagamentoLocal.cartao,
      dadosPessoais: this.dadosPagamentoLocal.dadosPessoais,
      sistema: this.dadosPagamentoLocal.sistema,
      perfil: this.dadosPagamentoLocal.perfil,
      parcelas,
    });
    //console.log(checkout);
    //Mais uma para a conta da matrícula - Nullificar cpd por causa da contabilidade com o Walter
    if(this.router.url.indexOf('contratante') !== -1){
      checkout.dadosPessoais.cpf = null;
    }
    checkout.sistema.servico.codigo = this.configuracoesCheckout[0].servico.codigo;

    const observerCheckout = this.checkoutService.efetuaPagamento(checkout);

    this.spinner.show();

    observerCheckout.subscribe((status) => {
      this.concluirPagamento(this.formasPagamento[1]);
      this.spinner.close();
      this.notification.success('Sucesso', 'Seu pagamento foi efetuado.');
    }, (err) => { this.spinner.close(); throw err; });
  }

  concluirPagamento(formaPagamento) {
    this.onPagamentoSucesso.emit(formaPagamento);
  }

  podePagarCartao(){
    //console.log(this.router.url);

    /**
     * Rematrícula - Habilitando novamente cartão euro 02/07/2020 - Felipe Goiabeira
     */
    /*if(this.environment.loginContexto=='EURO'&&this.router.url.indexOf('contratante') !== -1){
      return false;
    }*/
    //Cesup não tem cartão de crédito
    if(this.environment.loginContexto=='CESUP') return false;
    //Ceupi não tem cartão de crédito
    if(this.environment.loginContexto=='CEUPI') return false;
    return true;
  }
}
